// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e7caf3e0","534":"a7d50077","758":"579ca2d6"}[chunkId] + ".chunk.js";
};